import * as React from 'react';
import { StyledSkeletonInput } from './commonStyled';

export interface TextCellProps {
  loading?: boolean;
  value?: string;
}

const TextCell: React.FC<TextCellProps> = ({ value, loading }) => loading ? <StyledSkeletonInput size="small" /> : <>{value} </>;

export default TextCell;
